import { render, staticRenderFns } from "./gc-main-layout.vue?vue&type=template&id=0a076942"
import script from "./gc-main-layout.vue?vue&type=script&lang=js"
export * from "./gc-main-layout.vue?vue&type=script&lang=js"
import style0 from "./gc-main-layout.vue?vue&type=style&index=0&id=0a076942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports